define('views/modules/calendar/favorite/edit/form/favorite-edit-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/form/textbox',
    'views/parts/info-section',
    'src/views/form-view',
    // templates
    'text!templates/modules/calendar/favorite/edit/form/favorite-edit-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VTextBox,
    VInfoSection,
    VForm,
    // templates
    TFavoriteEditForm
) {

    var VFavoriteEditForm = VForm.extend({
        template: TFavoriteEditForm,

        regions: {
            name: '.name-input',
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, { item: opt.item, create: opt.create });

            this.view = {
                info: new VInfoSection({
                    title: "Favorite",
                    content: this.template,
                }),
                name: new VTextBox({ label: 'Name', labelposition: "top", attribute: 'name', model: this.model }),
            };

            this.listenTo(this.model, 'change', this.onModelChange)
                .listenTo(this.item, 'favorite:set:collection', this.onCollectionSet);
        },

        render: function() {
            this.assign(this.view.info, this.$el);             // append the form

            this.generateZones();
            this.assign(this.view.name, this.zone.$name);

            if (this.model.isNew()) {
                this.setDefaultName();
            }

            return this;
        },

        setDefaultName: function() {
            this.view.name.setValue(this.item.getName() || this.model.getDefaultName());
        },

        onSubmit: function() {
            if (!this.itemClone)
                this.itemClone = this.item;

            if (this.create) {
                this.item.trigger('favorite:create');
                this.model.set('data', this.itemClone.getFavoriteData());
            }
        },

        onModelChange: function() {
            this.trigger('model:change', this.isDirty());
        },

        onSuccess: function() {
            this.trigger('form:success', this.model.clone());
        },

        onCollectionSet: function(collectionAttr, models) {
            this.itemClone = this.item.clone();
            this.itemClone.set(collectionAttr, models);
        },

    });

    return VFavoriteEditForm;
});

